import { render } from "./Teaser.vue?vue&type=template&id=f7b88f5a&ts=true"
import script from "./Teaser.vue?vue&type=script&lang=ts"
export * from "./Teaser.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__